import { render, staticRenderFns } from "./NewFacebookPixelScreen.vue?vue&type=template&id=21f6e3ae&"
import script from "./NewFacebookPixelScreen.vue?vue&type=script&lang=ts&"
export * from "./NewFacebookPixelScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports